export default __webpack_public_path__ + "static/media/play_store.f1be9e5b.svg";